/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AzurePermissionsSwagger } from 'src/core/services/azure/azureSwaggers';

export const checkForAzurePermissions = (permissions: AzurePermissionsSwagger[], permissionsToCheck: AzurePermissionsSwagger) => {
    const actionPermissions = permissions.reduce((accPermissions, permission) => [...accPermissions, ...permission.actions], []);
    const notActionsPermissions = permissions.reduce((accPermissions, permission) => [...accPermissions, ...permission.notActions], []);
    const dataActionPermissions = permissions.reduce((accPermissions, permission) => [...accPermissions, ...permission.dataActions], []);
    const notDataActionsPermissions = permissions.reduce(
        (accPermissions, permission) => [...accPermissions, ...permission.notDataActions],
        []
    );

    return (
        checkPermissions(actionPermissions, permissionsToCheck.actions) &&
        checkPermissions(notActionsPermissions, permissionsToCheck.notActions) &&
        checkPermissions(dataActionPermissions, permissionsToCheck.dataActions) &&
        checkPermissions(notDataActionsPermissions, permissionsToCheck.notDataActions)
    );
};

const checkPermissions = (roles: string[], rolesToCheck: string[]) =>
    rolesToCheck.every(role =>
        roles.some(r => {
            const roleTokens = role.split('/');
            // Checks whether their is a higher level role.
            const genericRoles = roleTokens.reduce(
                (acc, _, rTokenIndex) => [
                    ...acc,
                    roleTokens
                        .slice(0, rTokenIndex)
                        .join('/')
                        .concat('/*')
                ],
                ['*']
            );

            return role === r || genericRoles.includes(r);
        })
    );
